const TABS = {
  LAYOUT: "layout",
  DESIGN: "design",
  SETTINGS: "settings",
  EDIT: "edit"
};

export { TABS };
//# sourceMappingURL=constants.js.map
